module.exports = __webpack_public_path__ + "img/women_with_bunny_ears.4f605240.gif";